import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getClientReport } from "../../services/clientService";
import Navbar from "../../components/Navbar";
import ClientReportHead from "../report/ClientReportHead";
import ClientReportExercises from "../report/ClientReportExercises";
import Biometrichexagon from "../report/Biometrichexagon";
import BodyWeight from "../report/BodyWeight";
import ReportNotes from "../report/ReportNotes";
import Reportbutton from "../report/Reportbutton";


//Mobile
import ClientReportHeadMobile from "../report/mobile/ClientReportHeadMobile";
import ClientReportExercisesMobile from "../report/mobile/ClientReportExercisesMobile";
import BiometrichexagonMobile from "../report/mobile/BiometrichexagonMobile";
import BodyWeightMobile from "../report/mobile/BodyWeightMobile";
import ReportNotesMobile from "../report/mobile/ReportNotesMobile";


const Dashboard = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const { report } = useSelector((state) => state.client);
  useEffect(() => {
    getClientReport();
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Navbar />
      {windowWidth > 1200 ? <ClientReportHead report={report} /> : <ClientReportHeadMobile report={report} />}
      {windowWidth > 1200 ? (
        <ClientReportExercises report={report} />
      ) : (
        <ClientReportExercisesMobile report={report} />
      )}

      {windowWidth > 1200 ? (
        <Biometrichexagon report={report} />
      ) : (
        <BiometrichexagonMobile report={report} />
      )}

      {windowWidth > 1200 ? (
        <BodyWeight report={report} />
      ) : (
        <BodyWeightMobile report={report} />
      )}

      {windowWidth > 1200 ? (
        <ReportNotes report={report} />
      ) : (
        <ReportNotesMobile report={report} />
      )}

 <Reportbutton /> 
      
    </div>
  );
};

export default Dashboard;
